import { Space } from "antd";
import * as React from "react";
import { EditButton, ViewMoreButton } from "src/components";

export type WebsiteSystemManageCellProps = {
  canEdit: boolean;
  onEdit: () => void;
  onHistory: () => void;
};

// Pure/presentational - see WebsiteSystemManageCell.test.tsx.
export const WebsiteSystemManageCell: React.FC<WebsiteSystemManageCellProps> = ({
  canEdit,
  onEdit,
  onHistory,
}) => (
  <Space>
    <ViewMoreButton size="small" onClick={onHistory} />
    {canEdit && <EditButton size="small" onClick={onEdit} />}
  </Space>
);
